import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Flex, Stack, Text } from "@similarweb/ui-components/foundations";

import { AlertsBreadcrumbs } from "./AlertsBreadcrumbs";
import { ExcelExportButton } from "./excel-export/ExcelExportButton";
import { CompetitorsFilter } from "./filters/competitors/CompetitorsFilter";
import { DurationSelectorContainer } from "./filters/duration-selector";
import { SubscribeButton } from "./subscribe-button/SubscribeButton";

export const NewHeader = () => {
    const { translate } = useTranslate();

    return (
        <Stack gap="16px">
            <AlertsBreadcrumbs />
            <Flex
                justifyContent="space-between"
                alignItems="center"
            >
                <Flex
                    gap="16px"
                    alignItems="center"
                >
                    <Text
                        fontVariant="h5_2"
                        color={colorsPalettes.carbon[500]}
                        flexShrink={0}
                    >
                        {translate("activation.alerts.page.title")}
                    </Text>
                    <DurationSelectorContainer />
                    <CompetitorsFilter />
                </Flex>
                <Flex
                    gap="8px"
                    alignItems="center"
                >
                    <ExcelExportButton />
                    <SubscribeButton />
                </Flex>
            </Flex>
        </Stack>
    );
};
